import appInfo from "@common/appInfo";
import Activity, { type ActivityItem } from "@common/components/Activity/component";
import { UserProfilePicture } from "@common/components/ProfilePicture/component";
import Hint from "@common/controls/Hint/component";
import Icon from "@common/controls/Icon/component";
import PreloaderDots from "@common/controls/Preloader/Dots/component";
import { IconType } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import { sort } from "@common/lib/array";
import { formatToHtml } from "@common/lib/format";
import { i18nFormat } from "@common/lib/i18n";
import { type Ai } from "@common/modules/ai/types";
import React from "react";

type Props = {
  agentName: string;
  data: Ai.ChatMessage.View.ChatMessage[];
  isNarrow?: boolean;
  welcomeMessage?: string;
};
export default (props: Props) => {
  const i18n = useI18n();

  const activityItems = React.useMemo<ActivityItem[]>(
    () =>
      sort(props.data, [{ key: "createdOnDate", type: "date" }, { key: "isAI" }]).map<ActivityItem>((x) => ({
        date: x.createdOnDate,
        description: x.message ? (
          <div
            dangerouslySetInnerHTML={{
              __html: formatToHtml(x.message)
            }}
          />
        ) : (
          <PreloaderDots text={i18n.typing} />
        ),
        icon: x.isAI ? (
          <Icon icon={IconType.Sparkles} />
        ) : (
          <UserProfilePicture
            email={null}
            firstName={appInfo.user?.userFirstName ?? i18n.guest}
            lastName={appInfo.user?.userLastName}
            profilePictureMediaSourceId={appInfo.user?.profilePictureMediaSourceId}
            profilePictureMediaSourceKey={"AwsS3"}
            size={32}
          />
        ),
        title: x.isAI ? props.agentName : appInfo.user?.displayName ?? i18n.guest,
        id: x.chatMessageId,
        isDateHidden: true,
        className: !!x.message ? undefined : "loading"
      })),
    [i18n, props.agentName, props.data]
  );

  const noDataMessage = React.useMemo(
    () =>
      props.welcomeMessage ? (
        <div className="welcome">
          <span className="title">
            {!!appInfo.user?.userFirstName
              ? i18nFormat(i18n.helloName, ["NAME", appInfo.user?.userFirstName])
              : i18n.hello}
          </span>
          <Hint>{props.welcomeMessage}</Hint>
        </div>
      ) : undefined,
    [i18n, props.welcomeMessage]
  );

  return (
    <Activity
      isBorderless
      isDateHidden
      isNarrow={props.isNarrow}
      isNoTitle
      noDataMessage={noDataMessage}
      options={activityItems}
      scrollTo="last"
    />
  );
};
